import { useEffect, useMemo, useState } from 'react';
import { SpeakerInfo } from '../types';
import { getInitials } from '@/components/atoms/Avatar/AvatarUtils';
import { classnames } from '@/libs/utils';

interface SpeakerAvatarProps {
  speaker: SpeakerInfo;
}

export function SpeakerAvatar({ speaker }: SpeakerAvatarProps) {
  const [showImage, setShowImage] = useState(!!speaker.profile_picture_url);

  useEffect(() => {
    setShowImage(!!speaker.profile_picture_url);
  }, [speaker.profile_picture_url]);

  const initials = useMemo(() => getInitials(speaker.name), [speaker.name]);

  const backgroundClass = speaker.bgColor || 'bg-slate-600';

  return (
    <div
      title={speaker.name}
      className={classnames(
        'flex size-6 shrink-0 items-center justify-center overflow-hidden rounded-full bg-cover bg-center text-xs font-medium text-white',
        backgroundClass
      )}
    >
      {showImage && speaker.profile_picture_url ? (
        <img
          src={speaker.profile_picture_url}
          alt={speaker.name}
          className="size-full object-cover"
          onError={() => setShowImage(false)}
        />
      ) : (
        <span>{initials}</span>
      )}
    </div>
  );
}
